import React from "react";
import { useTranslation } from "react-i18next";

import "./AddFolder.css";

export const AddFolder = ({ searchQuery, onSearchQueryChange }) => {
    const { t } = useTranslation();

    return (
        <div className="folder-menu-item add-folder">
            <input
                type="search"
                placeholder={t("folderMenu.searchPlaceholder")}
                value={searchQuery}
                onChange={(e) => onSearchQueryChange(e.target.value)}
            />
        </div>
    );
};
